import { FormControl, FormLabel, Input, FormErrorMessage } from "@chakra-ui/react";
import {
  BaseRate,
  BaseRateCreateViewModel,
  BaseRateUpdateViewModel,
} from "@common/loans/base-rate/base-rate.model";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { useResource } from "hooks/resources/providers/resourceProvider";
import { DataTableForm } from "components/elements/Datatable/data-table-form";
import { baseRateCreateSchema } from "@common/loans/base-rate/base-rate.schema";
import { baseRateUpdateSchema } from "@common/loans/base-rate/base-rate.schema";
import { PercentFieldV2 } from "components/elements/PercentField/percent-field.v2";
import { useContext } from "react";
import { LoanContext } from "providers/loan";

export function BaseRateForm() {
  const { loan } = useContext(LoanContext);
  const { modal } = useResource<BaseRate>();

  const baseRate = modal.selectedOne;

  const defaultValues = baseRate ? baseRate : { loan: loan?.id };

  const form = useForm<BaseRateCreateViewModel | BaseRateUpdateViewModel>({
    resolver: zodResolver(baseRate ? baseRateUpdateSchema : baseRateCreateSchema),
    defaultValues: defaultValues,
  });

  return (
    <DataTableForm<BaseRate, BaseRateCreateViewModel, BaseRateUpdateViewModel>
      resource="BaseRate"
      form={form}
      config={{
        size: "sm",
        resourceName: "Base Rate",
      }}
    >
      <Input {...form.register("loan")} type="hidden" />
      <FormControl isInvalid={!!form.formState.errors.rate} isRequired>
        <FormLabel>Rate</FormLabel>
        <PercentFieldV2
          value={form.getValues("rate")}
          onValueChange={value => form.setValue("rate", value.floatValue)}
        />
        <FormErrorMessage>{form.formState.errors.rate?.message}</FormErrorMessage>
      </FormControl>

      <FormControl isInvalid={!!form.formState.errors.effective_from} isRequired>
        <FormLabel>Effective From</FormLabel>
        <Input
          variant="primary"
          type="date"
          {...form.register("effective_from")}
          placeholder="Effective From"
        />
        <FormErrorMessage>{form.formState.errors.effective_to?.message}</FormErrorMessage>
      </FormControl>

      <FormControl isInvalid={!!form.formState.errors.effective_to}>
        <FormLabel>Effective To</FormLabel>
        <Input
          variant="primary"
          type="date"
          {...form.register("effective_to")}
          placeholder="Effective To"
        />
        <FormErrorMessage>{form.formState.errors.effective_to?.message}</FormErrorMessage>
      </FormControl>
    </DataTableForm>
  );
}
